import React from "react";
import { View, StyleSheet } from "react-native";
import NtRootPageContainer from "../../root/components/NtRootPageContainer";
import NtPageActionButton from "../../components/NtPageActionButton";
import NtPageSection from "../../components/NtPageSection";
import NtPagination from "../../components/NtPagination";
import NtSearchBar from "../../components/NtSearchBar";
import NtListHeader from "../../components/NtListHeader";
import NtListEmpty from "../../components/NtListEmpty";
import NtModal from "../../components/NtModal";
import NtUserItem from "../components/NtUserItem";
import NtUserNewForm from "../components/NtUserNewForm";
import BaseController from "../../common/base/BaseController";
import {
  asyncStorageSetData,
  showToast,
} from "../../common/utils/ControllerUtils";
import Logger from "../../common/utils/Logger";
import settings from "../../config/settings";
import routes from "../../navigation/routes";
import usercsvcolumndata from "../data/usercsvcolumndata";
import { fetchUsers } from "../../api/user";

class UserController extends BaseController {
  state = {
    ...super.state,
    loading: false,
    data: [],
    totalItems: 0,
    searchText: "",
    searchFilter: null,
    page: 1,
  };

  column_location = "@user_column_storage";
  addAccessModalRef = React.createRef();

  componentDidMount() {
    this.handleDefaultColumnsFetch(
      this.column_location,
      usercsvcolumndata.filter((each) => each.default === true),
    );
    this.handleDataFetch();
  }


  handleDataFetch = async () => {
    this.setState({ loading: true });
    const response = await fetchUsers(
      this.context.user?.domain,
      this.state.page,
      settings.pageSizeLoad,
      this.state.searchText,
      this.state.searchFilter,
    );
    Logger("Users fetch response", response);
    if (response.ok) {
      this.setState({
        data: response.data?.data || [],
        totalItems: response.data?.total || 0,
      });
    }
    this.setState({ loading: false });
  };

  handleExportFetch = async () => {
    const response = await fetchUsers(
      this.context.user?.domain,
      1,
      10000000,
      this.state.searchText,
      this.state.searchFilter,
    );
    return response.ok ? response.data.data : [];
  };

  handleExportDataParce = (item, column) => {
    if (column === "name") return item.contact?.contact_name_given;
    if (column === "user_enabled") return item[column] == "true" ? "Enabled" : "Disabled";
    return item[column];
  };

  handleSearch = (text) => {
    this.setState({ searchText: text, page: 1 }, () => this.handleDataFetch());
  };

  handlePageChange = (nextPage) => {
    this.setState({ page: nextPage }, () => this.handleDataFetch());
  };

  renderAddNewForm = () => (
    <NtModal ref={this.addAccessModalRef}>
      <NtUserNewForm
        onCancel={() => this.addAccessModalRef.current?.dismiss()}
        onCreate={() => {
          this.setState({ page: 1 }, () => this.handleDataFetch());
          this.addAccessModalRef.current?.dismiss();
          showToast("Success", "Successfully created the new User");
        }}
      />
    </NtModal>
  );

  renderRow = (item, index) => (
    <NtUserItem
      key={index}
      item={item}
      columns={this.state.columns}
      onPress={() => {
        this.props.navigation.navigate(routes.userdetails, { id: item.user_uuid });
      }}
    />
  );

  render() {
    const canEdit = this.handlePermissionCheck(settings.permissionTypeEdit);
    const count = this.state.totalItems || 0;
    const subtitle = `Manage user accounts, assigned extensions, and roles · ${count} user${count === 1 ? "" : "s"}`;

    const actions = canEdit ? (
      <NtPageActionButton
        icon="plus"
        title="Add User"
        variant="primary"
        onPress={() => this.addAccessModalRef.current?.show()}
      />
    ) : null;

    const searchBar = (
      <NtSearchBar value={this.state.searchText} onChangeText={this.handleSearch} />
    );

    return (
      <NtRootPageContainer
        pageTitle="Users"
        pageSubtitle={subtitle}
        permission={this.handlePermissionCheck()}
        actions={actions}
      >
        <NtPageSection
          search={searchBar}
          footer={
            <NtPagination
              page={this.state.page}
              pageSize={settings.pageSizeLoad}
              total={this.state.totalItems}
              onChange={this.handlePageChange}
            />
          }
        >
          <View style={styles.tableWrap}>
            <NtListHeader
              visible={this.state.data?.length > 0}
              headerContainerStyle={{ marginRight: canEdit ? 35 : 0 }}
              columns={usercsvcolumndata}
              selectedColumns={this.state.columns}
              onColumnUpdate={(updated) => {
                asyncStorageSetData(this.column_location, updated);
                this.setState({ columns: updated });
              }}
              exportFileName="users"
              exportDataParser={this.handleExportDataParce}
              exportFetchDataAsync={this.handleExportFetch}
            />
            <NtListEmpty visible={this.state.data?.length === 0} />
            {this.state.data?.map((each, index) => this.renderRow(each, index))}
          </View>
        </NtPageSection>

        {this.renderAddNewForm()}
      </NtRootPageContainer>
    );
  }
}

const styles = StyleSheet.create({
  tableWrap: { paddingHorizontal: 14, paddingVertical: 4 },
});

export default UserController;
